import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { KalHub } from '@/prakrit/components/grammar/kal/kal-hub'

const KalIndexPage: FC = (): ReactNode => (
    <Layout>
        <Seo
            title='The tenses'
            description='काल: every Prakrit tense on its own page, with the standard (सामान्य) and variant (विकल्प) endings for each person and number, examples and quick checks.'
        />
        <KalHub />
    </Layout>
)

export default KalIndexPage
